export default "__VITE_ASSET__4fe7acf7__"